import rootApi from './rootApi';
import fetchEntity from './saga';

export const sagaFetch = fetchEntity.bind(null, rootApi, false);

export const baseFetch = rootApi;

export default undefined;
